import Joi from 'joi';
import { MIN_LENGTH } from '../constants/EventCommentsConstants';

const COMMENT_TARGET_ERROR_MESSAGE = 'Select a user role.';
const COMMENT_ERROR_MESSAGE = 'Enter at least 10 characters.';

const EventCommentValidator = {
  schema: Joi.object({
    Id: Joi.number().allow(null).required(),
    CommentTarget: Joi.string().required().messages({
      'string.empty': COMMENT_TARGET_ERROR_MESSAGE
    }),
    Comment: Joi.string().min(MIN_LENGTH).required().messages({
      'string.empty': COMMENT_ERROR_MESSAGE,
      'string.min': COMMENT_ERROR_MESSAGE
    })
  })
};

export default EventCommentValidator;
